import moment from "moment";

export const CATS = [
  {
    title: "Saves",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "saves")?.value;
    },
  },
  {
    title: "Goals prevented",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "blockedScoringAtt")?.value;
    },
  },
  {
    title: "Throws",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "keeperThrows")?.value;
    },
  },
  {
    title: "Punches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "punches")?.value;
    },
  },
  {
    title: "Accurate passes",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "accuratePass")?.value;
    },
  },
  {
    title: "Touches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touches")?.value;
    },
  },
  {
    title: "Clearances",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalClearance")?.value;
    },
  },
  {
    title: "Tackles won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wonTackle")?.value;
    },
  },
  {
    title: "Ground duels won",
    calc: ({ stats }) => {
      return (
        stats?.find((s) => s?.type === "duelWon")?.value -
        stats?.find((s) => s?.type === "aerialWon")?.value
      );
    },
  },
  {
    title: "Aerial duels won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "aerialWon")?.value;
    },
  },
  {
    title: "Fouls committed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "fouls")?.value;
    },
  },
  {
    title: "Chances created",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalAttAssist")?.value;
    },
  },
  {
    title: "Dispossessed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "dispossessed")?.value;
    },
  },
  {
    title: "Fouled",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wasFouled")?.value;
    },
  },
  {
    title: "Shots",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalScoringAtt")?.value;
    },
  },
  {
    title: "Shots on target",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ontargetScoringAtt")?.value;
    },
  },
  {
    title: "Touches in Opp box",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touchesInOppBox")?.value;
    },
  },
  {
    title: "Offsides",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalOffside")?.value;
    },
  },
  {
    title: "Goals",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "goals")?.value;
    },
  },
];

export const DFB_CATS = [
  {
    title: "Saves",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "GoalkeeperSaves")?.value;
    },
  },
  {
    title: "Goals Prevented",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalBlocked")?.value;
    },
  },
  {
    title: "Passes",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "PassesSum")?.value;
    },
  },
  {
    title: "Passes Successful",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "PassesSuccessfulSum")?.value;
    },
  },
  {
    title: "Passsing Accuracy",
    statType: 1,
    calc: ({ stats }) => {
      const total = stats?.find((s) => s?.type === "PassesSum")?.value;
      const successful = stats?.find(
        (s) => s?.type === "PassesSuccessfulSum",
      )?.value;
      return total ? Math.round((successful / total) * 100) + "%" : "0%";
    },
  },
  {
    title: "Touches",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "BallActions")?.value;
    },
  },
  {
    title: "Clearances",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "DefensiveClearances")?.value;
    },
  },
  {
    title: "Tackles Won",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesWon")?.value;
    },
  },
  {
    title: "Ground Duels Won",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesGroundWon")?.value;
    },
  },
  {
    title: "Aerial Duels Won",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesAirWon")?.value;
    },
  },
  {
    title: "Fouls Committed",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "FoulsSum")?.value;
    },
  },
  {
    title: "Chances Created",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "AssistsShotAtGoal")?.value;
    },
  },
  {
    title: "Dispossessed",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "AbandonmentsOfBall")?.value;
    },
  },
  {
    title: "Fouls Won",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "FoulsSuffered")?.value;
    },
  },
  {
    title: "Shots",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalSum")?.value;
    },
  },
  {
    title: "Shots On Target",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsOnTarget")?.value;
    },
  },
  {
    title: "Offsides",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "Offsides")?.value;
    },
  },
  {
    title: "Goals",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalSuccessfull")?.value;
    },
  },
  {
    title: "Assists",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "Assists")?.value;
    },
  },
  {
    title: "xG",
    statType: 0,
    calc: ({ stats }) => {
      return parseFloat(
        stats?.find((s) => s?.type === "xG")?.value || 0,
      )?.toFixed(2);
    },
  },
  {
    title: "Top Speed",
    statType: 2,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "MaximumSpeed")?.value;
    },
  },
  {
    title: "Distance Covered",
    statType: 3,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "DistanceCovered")?.value;
    },
  },
  {
    title: "Goal Participations",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ParticipationsGoal")?.value;
    },
  },
  {
    title: "Dribbles",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "DribblingsSum")?.value;
    },
  },
  {
    title: "Dribbles Successful",
    statType: 0,
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "DribblingsSuccessful")?.value;
    },
  },
  {
    title: "Dribbles Successful",
    statType: 1,
    calc: ({ stats }) => {
      const total = stats?.find((s) => s?.type === "DribblingsSum")?.value;
      const successful = stats?.find(
        (s) => s?.type === "DribblingsSuccessful",
      )?.value;
      return total ? Math.round((successful / total) * 100) + "%" : "0%";
    },
  },
];

export function transformCustomStatValue(value, statType) {
  let v = value;
  if (statType === 1 && typeof v === "string") {
    v = v.replace("%", "");
  } else if (statType === 3 && v != null && v !== "") {
    v = parseFloat(v) / 1000;
  }
  return v ?? 0;
}

export class PlayerStats {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "PlayerStats";
    this.cb_scene = "Player Stats";
    this.ff_scene = "FF Player Stats";
    this.data = [];
  }

  preview({ options }) {
    if (options.customStatTitle) {
      this.buildCustomStat({ options });
      return;
    }
    this.onAir = false;
    this.data = [];
    if (options.full_frame) {
      this.scene = this.ff_scene;
    } else {
      this.scene = this.cb_scene;
    }
    if (options.type) {
      this.scene = this.scene + " " + options.type;
    }
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Stat Type",
      value: {
        text:
          options?.customStatType || "",
      },
    });

    this.data.push({
      name: "Title",
      value: {
        text: options.player.title || "",
      },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text:
          options.player.shirt_number ?? options.player.opta_shirt_number ?? "",
      },
    });

    this.data.push({
      name: "Position",
      value: {
        text: options.player?.squad?.position ?? "",
      },
    });

    this.data.push({
      name: "Image",
      value: {
        image: "${user}" + options?.player?.image,
      },
    });

    this.data.push({
      name: "First Name",
      value: {
        text: options.player.first_name ?? options.player.opta_first_name ?? "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player.last_name ?? options.player.opta_last_name ?? "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text:
          options.player.first_name_upper ??
          options.player.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text:
          options.player.last_name_upper ??
          options.player.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player.first_name ?? options.player.opta_first_name ?? "") +
          " " +
          (options.player.last_name ?? options.player.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player.first_name_upper ??
            options.player.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (options.player.last_name_upper ??
            options.player.opta_last_name?.toUpperCase() ??
            ""),
      },
    });

    this.data.push({
      name: "Nationality",
      value: {
        text:
          options?.player?.nationality?.code ??
          options?.player?.nationality?.opta_code,
      },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Goal Time",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
      if (options?.game?.opta_ID) {
        this.buildStats({
          stats: options?.game?.opta_player_stats?.home?.find(
            (p) => p?.player === options?.player?.opta_ID,
          ),
        });
      } else if (options?.game?.dfb_ID) {
        this.buildDFBStats({
          stats: options?.game?.sportec_player_stats?.home?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
      }
      try {
        this.data.push({
          name: "xG",
          value: {
            text:
              parseFloat(
                options?.game?.opta_xg_player_stats?.home
                  ?.find((p) => p?.player === options?.player?.opta_ID)
                  ?.stats?.find((s) => s?.type === "expectedGoals")?.value ?? 0,
              )?.toFixed(2) || 0,
          },
        });
      } catch (err) {}
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
      if (options?.game?.opta_ID) {
        this.buildStats({
          stats: options?.game?.opta_player_stats?.away?.find(
            (p) => p?.player === options?.player?.opta_ID,
          ),
        });
      } else if (options?.game?.dfb_ID) {
        this.buildDFBStats({
          stats: options?.game?.sportec_player_stats?.away?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
      }
      try {
        this.data.push({
          name: "xG",
          value: {
            text:
              parseFloat(
                options?.game?.opta_xg_player_stats?.away
                  ?.find((p) => p?.player === options?.player?.opta_ID)
                  ?.stats?.find((s) => s?.type === "expectedGoals")?.value ?? 0,
              )?.toFixed(2) || 0,
          },
        });
      } catch (err) {}
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  buildStats({ team, stats, options }) {
    CATS.map((cat) => {
      this.data.push({
        name: cat.title,
        value: {
          text: cat?.calc({ stats: stats.stats }) || 0,
        },
      });
    });
  }

  buildDFBStats({ team, stats, options }) {
    DFB_CATS.map((cat) => {
      this.data.push({
        name: cat.title,
        value: {
          text: cat?.calc({ stats: stats.stats }) || 0,
        },
      });
    });
  }

  buildCustomStat({ options }) {
    this.onAir = false;
    this.data = [];
    const {
      player,
      team,
      game,
      customStatTitle,
      customStatValue,
      customStatType,
      period,
    } = options;

    if (options.full_frame) {
      this.scene = this.ff_scene;
    } else {
      this.scene = this.cb_scene;
    }
    
    this.data.push({
      name: "Competition",
      value: { text: game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + (game?.competition?.badge || "") },
    });
    this.data.push({
      name: "Title",
      value: { text: player?.title || "" },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text: player?.shirt_number ?? player?.opta_shirt_number ?? "",
      },
    });
    this.data.push({
      name: "Image",
      value: { image: "${user}" + (player?.image || "") },
    });
    this.data.push({
      name: "First Name",
      value: { text: player?.first_name ?? player?.opta_first_name ?? "" },
    });
    this.data.push({
      name: "Last Name",
      value: { text: player?.last_name ?? player?.opta_last_name ?? "" },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (player?.first_name ?? player?.opta_first_name ?? "") +
          " " +
          (player?.last_name ?? player?.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Team Name",
      value: { text: team?.name || "" },
    });
    this.data.push({
      name: "Team Badge",
      value: { image: "${user}" + (team?.variables?.badge || "") },
    });
    const isHome = game?.home_team?._id === team?._id;
    const kit = isHome ? game?.home_team_kit : game?.away_team_kit;
    this.data.push({
      name: "Team Kit BG Colour",
      value: { colour: team?.variables?.[kit + "_kit_bg"] || "" },
    });
    this.data.push({
      name: "Team Kit Text Colour",
      value: { colour: team?.variables?.[kit + "_kit_text"] || "" },
    });
    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
    }
    

    this.data.push({
      name: "Custom Stat Title",
      value: { text: customStatTitle || "" },
    });
    this.data.push({
      name: "Custom Stat",
      value: { text: transformCustomStatValue(customStatValue, customStatType) },
    });
    this.data.push({
      name: "Stat Type",
      value: {
        text:
          game?.dfb_ID !== null ? (customStatType ?? 0) : (customStatType ?? ""),
      },
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
